import * as React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import MaterialTable, { Column } from 'material-table';
import Fab from '@material-ui/core/Fab';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import { RowDataLive } from 'src/reducers/liveorderfile';
import DescriptionSharpIcon from '@material-ui/icons/DescriptionSharp';
import { forwardRef } from 'react';
import { Icons } from 'material-table';
import CancelRoundedIcon from '@material-ui/icons/CancelRounded';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

interface TableState {
    columns: Array<Column<RowDataLive>>;
    data: RowDataLive[];
}

export interface NewOrderPageViewProps {
    newOrderData: RowDataLive[];
    reload: () => void;
    // onRowClick: (orderid: string, rowData: string) => void;
    // onDownloadClick: (orderno: string, fileName: string) => void;
    submitCancel: (column: Object) => void;
}
export const tableIcons: Icons = {
    Export: forwardRef((props, ref) => <DescriptionSharpIcon {...props} ref={ref} />)
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            height: 'calc(90vh - 64px)'
        },
        table: {
            // margin: theme.spacing(1),
            minWidth: 800,
        },
        forms: {
            width: '100%', // Fix IE 11 issue.
        },
        buttonSend: {
            // margin: theme.spacing(1),
            float: 'right',
            zIndex: 100,
            margin: '10px'
        },
        root1: {
            display: 'flex',
            height: '30vh'
        },
        fileUpload: {
            textAlign: 'center',
            fontSize: '18px',
            color: '#808080',
            height: '20vh',
            border: '2px solid #808080',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderStyle: 'dotted',
            '&:hover': {
                border: '4px solid #ff0000'
            }
        },
        iconbutton: {
            display: 'flex',
            '& > *': {
                margin: theme.spacing(1),
            },
            justifyContent: 'center'
        },
        paper: {
            backgroundColor: theme.palette.background.paper,
            borderRadius: '5px',
            boxShadow: theme.shadows[5],
            padding: theme.spacing(1),
        },
        HeadinG: {
            margin: theme.spacing(1),
            '& .MuiInputBase-input': {
                fontSize: '0.9rem'
            },
            '& .MuiButton-label': {
                fontSize: '0.7rem'
            },
            fontSize: '0.9rem'
        },
        // iconPadding: {
        //     padding: '6px'
        // },
        iconClose: {
            position: 'absolute',
            right: 0
        },
        button: {
            margin: theme.spacing(1),
        },
        textArea: {
            display: 'flex',
            justifyContent: 'center',
            margin: '20px'
        }
    })
);

const NewOrderPageView: React.StatelessComponent<NewOrderPageViewProps> = (props) => {
    const classes = useStyles({});
    const [open, setOpen] = React.useState(false);
    const [titleName, setTitle] = React.useState('');
    const [orderno, setOrderno] = React.useState('');
    const [msgApp, setMsgApp] = React.useState('');
    const handleClickOpen = (title: string, orderNo: string) => {
        setMsgApp('');
        setTitle(title);
        setOrderno(orderNo);
        setOpen(true);
    };

    const handleClose = () => {
        setOrderno('');
        setOpen(false);
    };
    const msgAppChange = (msgValue: string) => {
        setMsgApp(msgValue);
    };
    const handleCloseCancel = () => {
        setOpen(false);
        const columns = {
            columns: {
                caseno: orderno,
                ordaction: titleName,
                msg: msgApp.replace(/[\n\r]+/g, ' ').replace(/\s{2,}/g, ' ').replace(/^\s+|\s+$/, '').replace(/\"/g, '')
            },
            id: 'ordcr'
        };
        props.submitCancel(columns);
    };
    const [state] = React.useState<TableState>({
        columns: [
            {
                title: 'Order No',
                field: 'orderno',
                filtering: false,
                cellStyle: {
                    // padding: '5px 10px',
                    fontSize: '13px'
                }
            },
            // {
            //     title: 'Booking ID',
            //     field: 'refno',
            //     filtering: false,
            //     cellStyle: {
            //         // padding: '5px 10px',
            //         fontSize: '13px'
            //     }
            // },
            {
                title: 'Uploaded On',
                field: 'orderdate',
                filtering: false,
                cellStyle: {
                    // padding: '5px 10px',
                    fontSize: '13px'
                }
            },
            {
                title: 'File Name',
                field: 'fname',
                filtering: false,
                cellStyle: {
                    // padding: '5px 10px',
                    fontSize: '13px'
                }
            },
            {
                title: 'TAT',
                field: 'tat',
                filtering: false,
                cellStyle: {
                    // padding: '5px 10px',
                    fontSize: '13px'
                }
            },
            {
                title: 'Due By',
                field: 'dueby',
                filtering: false,
                cellStyle: {
                    // padding: '5px 10px',
                    fontSize: '13px'
                }
            },
            {
                title: 'Action',
                field: 'orderno',
                filtering: false,
                export: false,
                render: rowData => (
                    <div style={{ margin: 'auto' }}>
                        <Tooltip title="Cancel" placement="top">
                            <IconButton
                                aria-label="Cancel"
                                onClick={() => handleClickOpen('Cancel', rowData.orderno)}
                            // className={classes.iconPadding}
                            >
                                <CancelRoundedIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </div>
                ),
                cellStyle: {
                    padding: '0px',
                    textAlign: 'center'
                }
            },
        ],
        data: props.newOrderData
    });
    return (
        <div className={classes.root}>
            <Grid container justify="center" alignItems="center" >
                <Grid item xs={12} sm={12} md={12}>
                    <div>
                        <Fab color="primary" aria-label="add" style={{ height: '40px', width: '40px', float: 'left', margin: '12px', zIndex: 100 }} onClick={props.reload}>
                            <AutorenewIcon />
                        </Fab>
                    </div>
                    <Dialog
                        open={open}
                        onClose={handleClose}
                        fullWidth
                        maxWidth="sm"
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">Cancel Order</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                Are you sure to Cancel this Order {`${orderno}`} ?
                                <div className={classes.textArea}>
                                    <TextField
                                        id="outlined-multiline-static"
                                        label="Remarks"
                                        fullWidth
                                        multiline
                                        rows={4}
                                        autoFocus
                                        // defaultValue="Default Value"
                                        variant="outlined"
                                        onChange={(event) => msgAppChange(event.target.value as string)}
                                        value={msgApp}
                                    />
                                </div>
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleClose} color="primary">
                                No
                            </Button>
                            <Button onClick={handleCloseCancel} disabled={msgApp === ''} color="primary" autoFocus>
                                Yes
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <MaterialTable
                        icons={tableIcons}
                        title="Orders pending for submission"
                        columns={state.columns}
                        data={props.newOrderData}
                        localization={{
                            toolbar: {
                                exportTitle: 'Export as Excel'
                            },
                            header: {
                                actions: 'Cancel'
                            },
                            body: {
                                emptyDataSourceMessage: 'No orders to display'
                            }
                        }}
                        options={{
                            pageSizeOptions: [5, 10, 25, 50, 100],
                            sorting: true,
                            headerStyle: {
                                backgroundColor: '#757575',
                                color: '#fff',
                                padding: '10px',
                                textAlign: 'center'
                            },
                            exportButton: true,
                            exportAllData: true,
                        }}
                    />
                </Grid>
            </Grid>
        </div>
    );
};

export default NewOrderPageView;



// WEBPACK FOOTER //
// ./src/components/layouts/NewOrderPageView.tsx